import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '../../../services/auth';
import {Contract} from '../../../classes/contract';
import {ContractService} from '../../../services/contract';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";
import {User} from "../../../classes/user";
import {ChecklistCategoryIndicator} from "../../../classes/checklistCategoryIndicator";
import {ChecklistCategoryIndicatorService} from "../../../services/checklistCategoryIndicator";
import {mergeMap, tap} from "rxjs/operators";
import {saveAs} from "file-saver";
import {ChecklistCategoryService} from "../../../services/checklistCategory";
import {ReportService} from "../../../services/report";
import {InspectionService} from "../../../services/inspection";
import {Inspection} from "../../../classes/inspection";

@Component({
    selector: 'app-contract-detail',
    templateUrl: './contract-detail.component.html',
    styleUrls: ['./contract-detail.component.css']
})
export class ContractDetailComponent implements OnInit {
    // Pagination Parameters
    paginationConfig = {
        itemsPerPage: 10,
        currentPage: 1
    };
    paginationParams = {
        autoHide: true,
        maxSize: 7,
        responsive: true
    };
    paginationLabels = {
        previousLabel: 'Precedente',
        nextLabel: 'Successiva',
        screenReaderPaginationLabel: 'Paginazione',
        screenReaderPageLabel: 'pagina',
        screenReaderCurrentLabel: `Sei sulla pagina`
    };

    // Contract Data
    user!: User;
    contract!: Contract;
    checklistCategoryIndicators: Array<ChecklistCategoryIndicator> = [];
    inspectionsGeneralState = true;
    loadingOverlay = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private modalService: NgbModal,
                private contractService: ContractService,
                private checklistCategoryService: ChecklistCategoryService,
                private checklistCategoryIndicatorService: ChecklistCategoryIndicatorService,
                private inspectionService: InspectionService,
                private reportService: ReportService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.contractService.getByID(params.get('id'))
                .pipe(
                    tap((contract: any) => {
                        this.contract = contract;
                    }),
                    mergeMap(() => this.checklistCategoryIndicatorService.getByContractID(params.get('id'))),
                    tap((checklistCategoryIndicators: any) => {
                        this.checklistCategoryIndicators = checklistCategoryIndicators;
                    }),
                    mergeMap(() => this.checklistCategoryService.getByChecklistID(this.contract.fk_id_checklist.toString()))
                )
                .subscribe({
                    next: (checklistCategories: any) => {
                        if (this.checklistCategoryIndicators.length < checklistCategories.length) {
                            for (const checklistCategory of checklistCategories) {
                                if (!this.checklistCategoryIndicators.some((checklistCategoryIndicator: ChecklistCategoryIndicator) => {
                                    return checklistCategoryIndicator.fk_id_checklist_category === checklistCategory.id_checklist_category;
                                })) {
                                    let currentChecklistCategoryIndicator = new ChecklistCategoryIndicator();
                                    currentChecklistCategoryIndicator.fk_id_contract = this.contract.id_contract as number;
                                    currentChecklistCategoryIndicator.contract = this.contract;
                                    currentChecklistCategoryIndicator.fk_id_checklist_category = checklistCategory.id_checklist_category;
                                    currentChecklistCategoryIndicator.checklist_category = checklistCategory;
                                    this.checklistCategoryIndicators.push(currentChecklistCategoryIndicator);
                                }
                            }
                        }
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
            this.checklistCategoryIndicatorService.getByContractID(params.get('id'))
                .subscribe({
                    next: (checklistCategoryIndicators: any) => {
                        if (checklistCategoryIndicators.length > 0) {
                            this.checklistCategoryIndicators = checklistCategoryIndicators;
                        } else {

                        }
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
            this.inspectionService.getByIDContract(params.get('id'))
                .subscribe({
                    next: (inspections: any) => {
                        inspections.forEach((inspection: Inspection) => {
                            if (inspection.fk_id_inspection_state !== 5) {
                                this.inspectionsGeneralState = false;
                            }
                        });
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
        this.user = this.authService.getUser();
    }

    pageChanged(event: any) {
        this.paginationConfig.currentPage = event;
    }

    openGenerateReport() {
        this.loadingOverlay = true;
        this.route.paramMap.subscribe(params => {
            this.reportService.create(params.get('id'), this.contract.fk_id_checklist.toString())
                .subscribe({
                    next: (blobFile) => {
                        saveAs(blobFile);
                        this.loadingOverlay = false;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                        this.loadingOverlay = false;
                    }
                });
        });
    }

    openDeleteContractModal() {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Contract</strong>';
        modalRef.componentInstance.text = 'Confermi la rimozione della convenzione "' + this.contract.name + '"?';
        modalRef.result.then(() => {
            if (this.contract.id_contract) {
                this.contractService.delete(this.contract.id_contract)
                    .subscribe({
                        next: () => {
                            this.router.navigate(['/contract']);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    updateChecklistCategoryIndicators() {
        for (const checklistCategoryIndicator of this.checklistCategoryIndicators) {
            if (checklistCategoryIndicator.id_checklist_category_indicator === undefined) {
                // Creates new indicator
                this.checklistCategoryIndicatorService.create(checklistCategoryIndicator)
                    .subscribe({
                        next: () => {
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            } else {
                // Update existing indicator
                this.checklistCategoryIndicatorService.update(checklistCategoryIndicator)
                    .subscribe({
                        next: () => {
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        }
    }
}
